import { render } from "./AppSetPrice.vue?vue&type=template&id=34100c67&scoped=true"
import script from "./AppSetPrice.vue?vue&type=script&lang=js"
export * from "./AppSetPrice.vue?vue&type=script&lang=js"

import "@/Common/Styles/appSetPriceModal.scss?vue&type=style&index=0&id=34100c67&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34100c67"]])

export default __exports__